import { render, staticRenderFns } from "./VideoRender.vue?vue&type=template&id=40f4f2b6&scoped=true&"
import script from "./VideoRender.vue?vue&type=script&lang=ts&"
export * from "./VideoRender.vue?vue&type=script&lang=ts&"
import style0 from "./VideoRender.vue?vue&type=style&index=0&id=40f4f2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4f2b6",
  null
  
)

export default component.exports